import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import SignalRService from "../Services/Api/SignalRService";

const ALLOWED_ROUTES = ["/ride"];

const AppSignalRManager = () => {
    const location = useLocation();
    // const prevPath = useRef(null);

    useEffect(() => {
        // const currentPath = location.pathname;
        // const prev = prevPath.current;
        // const wasConnected = ALLOWED_ROUTES.includes(prev);
        // const shouldConnect = ALLOWED_ROUTES.includes(currentPath);

        // // only start if we entered an allowed route from a disallowed route
        // if (shouldConnect && !wasConnected) {
        //     SignalRService.startSignalRConnection();
        // }

        // // only stop if we left an allowed route
        // if (!shouldConnect && wasConnected) {
        //     SignalRService.stopSignalRConnection();
        // }

        // prevPath.current = currentPath;

        // if not rides then stop the connection
        if (!ALLOWED_ROUTES.includes(location.pathname)) {
            SignalRService.stopSignalRConnection();
        }

        return () => {
            // only stop if we're leaving the app entirely
            // (this is optional based on your desired behavior)
        };
    }, [location.pathname]);

    return null;
};

export default AppSignalRManager;
